import { falsy } from '~/helpers/type'
type ValidFacetKey = string

export default function () {
  const route = useRoute()

  const getActiveTermsForFacet = (facetKey: ValidFacetKey): string[] => {
    const queryValue = route.query[facetKey]

    if (typeof queryValue === 'string' && queryValue) {
      return [queryValue]
    } else if (Array.isArray(queryValue)) {
      return queryValue.map((v) => v && v.toString()).filter(falsy)
    }
    return []
  }

  const calculateFacets = (currentFacets: string[], termKey: string) => {
    const isSelected = currentFacets.includes(termKey)
    return isSelected
      ? currentFacets.filter((v) => v !== termKey)
      : [...currentFacets, termKey]
  }

  const termIsActive = (
    facetKey: ValidFacetKey,
    termKey: string,
  ): ComputedRef<boolean> =>
    computed(() => route.fullPath.includes(`${facetKey}=${termKey}`))

  const buildFacetTermLink = (facetKey: ValidFacetKey, termKey: string) => {
    const to = computed(() => {
      const currentFacets = getActiveTermsForFacet(facetKey)
      const facets = calculateFacets(currentFacets, termKey)
      return {
        path: route.path,
        query: {
          ...route.query,
          [facetKey]: facets.length ? facets : undefined,
          page: undefined,
        },
      }
    })
    const active = termIsActive(facetKey, termKey)

    return {
      to,
      active,
    }
  }

  return {
    buildFacetTermLink,
    getActiveTermsForFacet,
    termIsActive,
  }
}
